import { Component, OnInit, ViewChild } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { Router } from "@angular/router";
import { Datamanager } from "src/app/model/Datamanager";
import { Page } from "src/app/model/Page";
import { ExportImportService } from "src/app/services/export-import.service";

@Component({
  selector: "app-secure-export-apps",
  templateUrl: "./export-apps.component.html",
  styleUrls: ["./export-apps.component.scss"],
})
export class ExportAppsComponent implements OnInit {
  page: Page<Datamanager>;
  isLoading = false;
  form: FormGroup = new FormGroup({});
  isSubmitDisabled: boolean = false;
  lotteryList: {[key: number]: string};
  reports: {[key: number]: string};

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  dataSource: MatTableDataSource<Datamanager> = new MatTableDataSource();
  displayedColumns: string[] = [
    "key",
    "lottery",
    "actionTime",
    "status",
    "action",
  ];
  pageSizeOptions: number[] = [10, 25, 100];
  totalRows = 0;
  pageSize = 10;
  currentPage = 0;

  constructor(
    private router: Router,
    private exportImportService: ExportImportService
  ) {}

  ngOnInit(): void {
    this.loadData();
    this.form = new FormGroup({
      lotteryKey: new FormControl("", Validators.required),
    });
  }

  loadData() {
    this.isLoading = true;
    this.exportImportService.initExportAppsForm(this.currentPage, this.pageSize)
    .subscribe((data) => {
        this.page = data.datamanagerList;
        this.lotteryList = data.lotteryList;
        this.dataSource = new MatTableDataSource(data.datamanagerList.content);
        setTimeout(() => {
          this.paginator.pageIndex = this.currentPage;
          this.paginator.length = data.datamanagerList.totalElements;
        });
        this.isLoading = false;
      },
      (error) => {
        this.exportImportService.errorToast(error?.error?.message || error?.error?.errorMessage);
        this.isLoading = false;
      }
    );
  }

  onSubmit() {
    if (this.form.valid) {
      this.isLoading = true;
      this.exportImportService.exportApplications(this.form.value.lotteryKey.key)
      .subscribe((data) => {
        this.isSubmitDisabled = false;
        this.isLoading = false;
        if(data.status === 'SUCCESS') {
          this.exportImportService.successToast('Data Export started.');
          setTimeout(() => {
            this.ngOnInit();
          }, 2000);
        }
        else {
          this.exportImportService.errorToast(data.errorMessage);  
        }
      }, error => {
        this.isLoading = false;
        this.isSubmitDisabled = false;
        this.exportImportService.errorToast(error?.error?.message||error?.errorMessage||error?.error?.errorMessage);
      });
    }
    else {
      this.isSubmitDisabled = false;
    }
  }

  refresh() {
    this.loadData();
  }

  downloadENC(key: number){
    this.isLoading = true;
    this.exportImportService.downloadENC(key)
    .subscribe((data) => {
      this.isSubmitDisabled = false;
      this.isLoading = false;
      this.isLoading = false;
      if(data.status === 'SUCCESS') {
        this.downloadFile(data.base64File, data.fileName);
      }
      else {
        this.exportImportService.errorToast(data.errorMessage);  
      }
    }, error => {
      this.isLoading = false;
      this.isSubmitDisabled = false;
      this.exportImportService.errorToast(error?.error?.message||error?.errorMessage||error?.error?.errorMessage);
    });
  }

  printHashCode(key: number) {
    this.isLoading = true;
    this.exportImportService.printExportApplicationsHashCode(key)
    .subscribe((data) => {
      this.isSubmitDisabled = false;
      this.isLoading = false;
      this.isLoading = false;
      if(data.status === 'SUCCESS') {
        this.downloadFile(data.base64File, data.fileName);
      }
      else {
        this.exportImportService.errorToast(data.errorMessage);  
      }
    }, error => {
      this.isLoading = false;
      this.isSubmitDisabled = false;
      this.exportImportService.errorToast(error?.error?.message||error?.errorMessage||error?.error?.errorMessage);
    });
  }

  downloadFile(base64:string | ArrayBuffer, fileName:string){
    const src = `${base64}`;
    const link = document.createElement("a")
    link.href = src
    link.download = fileName
    link.click()
    
    link.remove()
  }

  pageChanged(event: PageEvent) {
    console.log({ event });
    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex;
    this.loadData();
  }
}